// 明星绯闻与幕后花絮（演示性策划内容，含传闻/未证实提示）
export const gossipTimeline = [
  {
    date: "2025.09.18",
    level: "媒体报道",
    title: "车瑞妍与徐河准被拍到同游济州岛",
    desc: "有媒体称拍到两人在济州岛同行。双方经纪公司回应「艺人的私生活难以逐一确认」，未承认也未否认，传闻因此持续升温。",
    tags: ["车瑞妍", "徐河准"],
  },
  {
    date: "2025.08.30",
    level: "已确认",
    title: "李道勋加盟木工公益项目",
    desc: "经纪公司确认李道勋将利用拍摄空档参与乡村校舍的木工修缮。这是他继去年之后第二次参与同类公益，与其「爱做木工」的爱好有关。",
    tags: ["李道勋"],
  },
  {
    date: "2025.07.22",
    level: "传闻",
    title: "金慕妍与旧东家续约传闻",
    desc: "业内传闻金慕妍与青丘娱乐的续约谈判一度陷入僵局。目前双方均未发布正式声明，消息仍停留在传闻阶段。",
    tags: ["金慕妍"],
  },
  {
    date: "2025.06.11",
    level: "媒体报道",
    title: "姜泰允被目击探班《黄金帝国》剧组",
    desc: "有粉丝称在片场外看到已杀青的姜泰允回组探班，与工作人员合影。剧组回应是「正常的杀青后回访」，未涉及其它内容。",
    tags: ["姜泰允"],
  },
  {
    date: "2025.05.04",
    level: "已确认",
    title: "《四季食堂》确认制作特别篇",
    desc: "制作方正式宣布《四季食堂》将推出两集特别篇，原班主创回归。罗美淑、金慕妍、韩素珍均已确认出演。",
    tags: ["四季食堂"],
  },
  {
    date: "2025.03.27",
    level: "传闻",
    title: "吴世琳或将主演新剧《今日晴》",
    desc: "有报道称吴世琳正在洽谈新剧女主。截至目前经纪公司仅表示「收到邀约，正在讨论」，尚未定案。",
    tags: ["吴世琳"],
  },
];

// 幕后花絮
export const behindScenes = [
  {
    id: "bts-1",
    title: "《首尔月台》那场戏，台词其实是即兴的",
    category: "拍摄现场",
    drama: "首尔月台",
    likes: 1284,
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20Korean%20drama%20shoot%2C%20film%20set%20on%20a%20vintage%20train%20platform%20with%20softbox%20lights%20and%20camera%20crew%2C%20actors%20rehearsing%20between%20takes%2C%20warm%20amber%20and%20cream%20tones%2C%20candid%20documentary%20photography%2C%20cozy%20cinematic%20mood&width=900&height=600&seq=hd-bts-01&orientation=landscape",
    desc: "导演透露，月台重逢的那段对白有近一半是两位主演临场商量出来的。车瑞妍说，现场的风太大，按原台词演反而不像真的，于是两人干脆用最朴素的话把戏接了下去，最后剪进正片的正是即兴版本。",
  },
  {
    id: "bts-2",
    title: "《四季食堂》片场的「真饭菜」传统",
    category: "道具趣闻",
    drama: "四季食堂",
    likes: 967,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20behind%20the%20scenes%20photo%20of%20a%20Korean%20drama%20food%20scene%2C%20rustic%20kitchen%20set%20with%20real%20steaming%20home%20cooked%20dishes%20and%20fresh%20vegetables%2C%20prop%20stylist%20arranging%20plates%2C%20soft%20daylight%20through%20window%2C%20terracotta%20and%20cream%20palette%2C%20candid%20documentary%20photography%2C%20cozy%20mood&width=900&height=600&seq=hd-bts-02&orientation=landscape",
    desc: "《四季食堂》里出现的每道菜都是真实可吃的。道具组会提前按当季食材备好，演员拍完就能直接吃。金慕妍笑称，拍完这部剧自己胖了三公斤，剧组于是把「减重目标」写进了通告单。",
  },
  {
    id: "bts-3",
    title: "《汉江以北》的雨天戏，拍了整整三夜",
    category: "拍摄现场",
    drama: "汉江以北",
    likes: 842,
    image:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20film%20set%20of%20a%20Korean%20crime%20drama%2C%20crew%20in%20raincoats%20with%20camera%20rig%20and%20rain%20towers%20on%20a%20wet%20city%20street%2C%20glowing%20street%20lamps%20reflected%20on%20asphalt%2C%20deep%20charcoal%20and%20amber%20tones%2C%20candid%20documentary%20photography%2C%20moody%20cinematic%20atmosphere&width=900&height=600&seq=hd-bts-03&orientation=landscape",
    desc: "为了那场贯穿全剧的关键雨戏，剧组连续三个通宵调度降雨车。郑宇彬坚持不用替身，在低温里把自己淋到嘴唇发白，收工后却说：「观众记得住，就值了。」",
  },
  {
    id: "bts-4",
    title: "《黄金帝国》会议室里的道具账本",
    category: "道具趣闻",
    drama: "黄金帝国",
    likes: 715,
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20Korean%20business%20drama%2C%20elegant%20boardroom%20set%20with%20detailed%20vintage%20ledger%20books%20and%20papers%20on%20a%20marble%20table%2C%20warm%20brass%20lamps%20and%20deep%20burgundy%20upholstery%2C%20prop%20designer%20adjusting%20details%2C%20soft%20moody%20lighting%2C%20candid%20documentary%20photography&width=900&height=600&seq=hd-bts-04&orientation=landscape",
    desc: "贯穿全剧的那本旧账本是道具组手工做的，内页密密麻麻写满了三十年的虚构账目。导演要求每一页都「翻得出来」，因为镜头真的会特写。姜泰允说，他每次翻开都忍不住认真读下去。",
  },
];